import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'shared-components/src/utils/http';
import { Button, Loader, ErrorComponent } from 'shared-components';
import Heading from '../../components/Heading';
import Card from '../../components/Card';
import Text from '../../components/Text';
import { DocumentList, DocumentRow, DocumentName } from './styles';

const PAGE = 'tax-documents';

const TaxDocuments = () => {
  const [t4as, setT4As] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cardholderData = await get(
          '/api/v1/cardholder_portal/cardholder'
        );
        const account = cardholderData.data.accounts.find(
          acc =>
            acc.processor_reference ===
            cardholderData.data.primary_processor_reference
        );

        const response = await get(
          `/api/v1/cardholder_portal/cardholder/accounts/${account.id}/t4as`
        );
        setT4As(response.t4as || []);
      } catch (e) {
        setError(true);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleView = taxYear => {
    window.open(`/tax-documents/${taxYear}`, '_blank');
  };

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  return (
    <>
      <Heading page={PAGE} heading="Tax Documents" />
      <Card>
        {t4as.length === 0 ? (
          <Text page={PAGE} textFor="no-documents" text="No tax documents available." />
        ) : (
          <DocumentList>
            {t4as.map((t4a) => (
              <DocumentRow key={t4a.tax_year}>
                <DocumentName>
                  T4A &mdash; {t4a.tax_year}
                </DocumentName>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => handleView(t4a.tax_year)}
                >
                  <FormattedMessage
                    id={`${PAGE}-download-button`}
                    defaultMessage="Download"
                  />
                </Button>
              </DocumentRow>
            ))}
          </DocumentList>
        )}
      </Card>
    </>
  );
};

export default TaxDocuments;
